import * as React from 'react';
import axios from 'axios';
import LogPlusAnyResourcesAutocomplete from './LogPlusAnyResourcesAutocomplete';
import { IServiceListItem } from './IModels';
import { LogPlusServiceAutocompleteOption } from './LogPlusAutocompleteOption';

interface GetServicesAutocompleteResult {
	success: boolean,
	status?: "LogDisabled",
	items?: IServiceListItem[]
}

export interface IAutocompleteParams {
	maxRows: number,
	filterId?: string,
}

interface IProps<T> {
	value: T[],
	onSelect: (value: T[]) => void,
	multiple?: true | false,
	placeholderText?: string,
	error: boolean;
	helperText: string,
	searchIn: string,
	filterId: string,
}

export default function LogPlusServicesAutocomplete(props: IProps<IServiceListItem>) {

	return (<ServiceAutocomplete
		value={props.value}
		onSelect={props.onSelect}

		searchIn={props.searchIn?.split(',') as (keyof IServiceListItem)[]}
		error={props.error}
		helperText={props.helperText}
		multiple={props.multiple}
		filterId={props.filterId}
	/>);
}

interface IServiceAutocompleteProps {
	value: IServiceListItem[],
	onSelect: (value: IServiceListItem[]) => void,
    multiple?: true | false,
    placeholderText?: string,
    error?: boolean;
    helperText?: string,

	searchIn: (keyof IServiceListItem)[],
	filterId: string,
}

function ServiceAutocomplete(props: IServiceAutocompleteProps)
{
	const getOptionSelected = (option: IServiceListItem, value: IServiceListItem) => {
		return option.Id === value.Id;
	}

	return (<LogPlusAnyResourcesAutocomplete
		{...props}
		getOptionLabel={(option: IServiceListItem) => option.Name}
		getOptionSelected={getOptionSelected}
		createRequest={(text: string) => {
			return {
				text: text,
			}
		}}
		loadOptions={(request, callback) => {

			axios.get<GetServicesAutocompleteResult>('/LogPlusResources/GetServicesAutocomplete/', {
				params: {
					search: request.text,
					searchIn: props?.searchIn?.join(','),
					max: 20,
					filterId: props?.filterId
				}
			})
				.then(r => {
					callback(r.data.items);
				});
		}}
		renderOption={(option) => <LogPlusServiceAutocompleteOption
			name={option.Name}
			option={option}
			searchIn={props.searchIn}
		/>}
	/>)
}